<template>
  <div class="tools-captioned">
    <a
      id={{@id}}
      class="tools-button"
      aria-label={{@title}}
      href={{@href}}
      tabindex="0"
      title={{@tooltip}}
      data-qa-element="aps_{{@qaName}}_btn"
      ...attributes
    >
      <div class="svg-button-icon">
        <svg class="svg-icon" focusable="false">
          {{!template-lint-disable no-unnecessary-concat}}
          <use class="appicon-external" xlink:href="{{@icon}}"></use>
        </svg>
      </div>
    </a>
    <label class="tools-text" for={{@id}} data-qa-element="aps_{{@qaName}}_label">
      {{@title}}
    </label>
  </div>
</template>
